/* eslint-disable @typescript-eslint/no-explicit-any */

import { TransferSourceType } from 'types/generalType';

interface WithdrawCash {
  PIN?: string;
  Amount?: string;
  CountryCode?: string;
  GatewayOperationType?: string;
  SourceWallet?: string;
  TargetCurrency?: string;
  TargetCountryCode?: string;
  TargetType?: string;
  SourceType?: string;
  TargetWallet?: string;
  DestCountryCode?: string;
  transferConfirmation?: any;
  requestCashBack?: any;
  otherKeys?: any;
}

export const WithdrawCashConfirmation = ({
  Amount,
  CountryCode,
  GatewayOperationType,
  SourceWallet,
  TargetCurrency,
  TargetCountryCode,
  SourceType = TransferSourceType.BANK,
  TargetType,
  transferConfirmation,
  otherKeys,
}: WithdrawCash) => {
  const payload: any = {
    Amount,
    CountryCode,
    GatewayOperationType,
    SourceWallet,
    TargetCurrency,
    TargetCountryCode,
    SourceType,
    TargetType,
    ...otherKeys,
  };

  transferConfirmation(payload);
};

export const CashBackRequest = ({
  Amount,
  PIN,
  SourceWallet,
  TargetWallet,
  DestCountryCode,
  requestCashBack,
  SourceType = TransferSourceType.BANK,
  otherKeys,
}: WithdrawCash) => {
  const payload = {
    Amount,
    PIN,
    SourceWallet,
    TargetWallet,
    DestCountryCode,
    SourceType,
    ...otherKeys,
  };

  requestCashBack(payload);
};
